module.exports = __webpack_public_path__ + "img/profile_banner.e0f5fcd3.png";